import React from "react";
import { View, Text, Modal, StyleSheet, TouchableOpacity } from "react-native";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../_layout";

import { useTranslation } from "react-i18next";
import GlobalStyles from "../../Resources/Styles";

const OfflineAlert = ({ isVisible, onClose }) => {
  const screenSize = useScreenDimensions();
  const { t } = useTranslation();
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={onClose}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                maxWidth: screenSize === "small" ? 300 : 400,
                width: "90%",
                padding: 16,
              },
            ]}
          >
            <View
              style={{
                alignItems: "center",
                // backgroundColor: "red",
                width: "100%",
                height: 80,
                // marginBottom: 20,
                justifyContent: "center",
              }}
            >
              <View
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: 32,
                  backgroundColor: Colors.bubbleColor,
                  opacity: 0.06,
                  position: "absolute",
                }}
              />
              <View
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 24,
                  backgroundColor: Colors.bubbleColor,
                  opacity: 0.08,
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  position: "absolute",
                }}
              />
              <View
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 24,
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                  position: "absolute",
                }}
              >
                <Ionicons
                  name="cloud-offline"
                  size={24}
                  color={Colors.bubbleColor}
                />
              </View>
            </View>
            <View
              style={{
                alignItems: "center",
                width: "100%",
                height: 100,
                justifyContent: "center",
              }}
            >
              <Text
                style={[
                  screenSize === "small" ? Fonts.medium16 : Fonts.medium16,
                  {
                    textAlign: "center",
                    color: Colors.blackColor,
                    // marginTop: 32,
                  },
                ]}
              >
                {t("offlineAlertTitle-string")}
              </Text>

              <Text
                style={[
                  screenSize === "small" ? Fonts.regular14 : Fonts.regular14,
                  {
                    textAlign: "center",
                    color: Colors.grayColor,
                    marginTop: 8,
                  },
                ]}
              >
                {t("offlineAlertText-string")}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center", // Center the modal horizontally
  },

  modalView: {
    alignSelf: "center",
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    // paddingHorizontal: 30,
    // paddingVertical: 20,
  },

  touchableBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(15, 15, 15, 0.2)",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default OfflineAlert;
